import { render } from "./AccountView.vue?vue&type=template&id=39ceb1c9&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import "./AccountView.vue?vue&type=style&index=0&id=39ceb1c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ceb1c9"]])

export default __exports__